import GradeRecordRepository from '../../domain/repositories/GradeRecordRepository';
import GradeRecordDataStoreFactory from '../factories/GradeRecordDataStoreFactory';
import GradeRecordDataStore from '../datastores/GradeRecordStore';

export default class CourseGradeRecordRepository
  implements GradeRecordRepository
{
  getCoursesGradeRecord() {
    const courseGradeRecordDataStore: GradeRecordDataStore =
      GradeRecordDataStoreFactory.create();
    return courseGradeRecordDataStore.getCoursesGradeRecord();
  }
}
